module.exports = __webpack_public_path__ + "static/media/carrier-active-hub.22dc65a1.svg";